import { call, put } from 'redux-saga/effects';
import {
  resetPasswordEmailFailure,
  resetPasswordEmailSuccess,
} from '../actions';
import { resetPasswordEmail } from '../api';
import { ResetPasswordEmailRequestAction } from '../types';
import { ApiError } from 'store/api/types';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import { push } from 'store/navigation/actions';
import routes from 'routes';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* resetPasswordEmailSaga(
  action: ResetPasswordEmailRequestAction
) {
  try {
    let err: ApiError | null;

    const { user } = action.payload;

    const response = yield call(resetPasswordEmail, user);

    //err = checkResponse(response?.responseMessage);
    //if (err) throw err;

    yield put(push(routes.resetPassword.emailSent));
    yield put(resetPasswordEmailSuccess());
  } catch (error) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(resetPasswordEmailFailure());
  }
}
